import * as Yup from 'yup';

export const validationSchemaSendMail = Yup.object({
    username: Yup.string().min(3,'Minimo 3 caracteres').max(20, 'Maximo 20 caracteres').required('Requerido'),
});